const local_storage_token_location = "ext-at";
const lang = "prefered-lang";

export function setPreferedLanguage(locale) {
  localStorage.setItem(lang, locale);
}

export function getPreferedLanguage() {
  const storedLang = localStorage.getItem(lang);
  return storedLang || "en-US";
}

export function getLanguageOptions() {
  return ["en-US", "sv-SE", "fi-FI", "nb-NO"];
}

export function tokenExist() {
  if (localStorage.getItem(local_storage_token_location) === null) {
    return false;
  }
  return true;
}

